import styled from "styled-components";

export const ValuePropositionSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px;
  background-color: ${({ theme }) => theme.colorsPalette.black.darker};

  @media (max-width: 600px) {
    padding: 40px;
  }
`;

export const ValuePropositionSubsectionContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin: auto;
  margin-top: 16px;

  @media (max-width: 600px) {
    flex: 1;
    flex-direction: column;
  }
`;

export const ValuePropositionImg = styled.img`
  position: absolute;
  height: 400px;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 11%) 0px 1px 20px 3px;
`;
